import styled from "styled-components";

export const StyleSkills = styled.div`
  margin-top: 3rem;

  div.skillsHeader {
    font-size: 3rem;
    text-transform: Uppercase;
    text-align: center;
    font-weight: 600;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #dbb765;
    border: 5px solid #8f6e25;
    border-top: none;
    border-right: none;
    width: max-content;
    text-align: center;
    margin: 0 auto;
    padding: 0.5rem;
    svg {
      padding-top: 10px;
    }
    @media screen and (max-width: 600px) {
      font-size: 2rem;
    }
  }
  ul {
    margin: 1.5rem 0.5rem;
    li {
      list-style: none;
      margin: 1.5rem auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-direction: column;
      div.skillType {
        font-size: 1.3rem;
        opacity: 0.6;
        font-weight: 200;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 90%;
        border-bottom: 1px solid var(--priColor);
      }
      div.Frontend,
      div.UserInterface {
        justify-content: flex-start;
      }
      div.Backend,
      div.otherTechnologies {
        justify-content: flex-end;
      }

      div.skills {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0.5rem 1rem;
        div.splide {
          margin: 0;
          padding: 0;
          width: 90vw;
        }
        div.skillContainer {
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
          div.frIcon,
          div.brIcon,
          div.techIcon {
            font-size: 5rem;
            @media screen and (max-width: 767px) {
              font-size: 3rem;
            }
            @media screen and (max-width: 600px) {
              font-size: 2rem;
            }
          }

          div {
            margin-top: 0.4rem;
            letter-spacing: 0.2rem;
          }
        }
      }
    }
  }
`;
